module.exports = __webpack_public_path__ + "img/daily-calendar.a8f905e8.png";